import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import usePaginator from "../../../../theme/Component/usePaginator";
import { _PayrollConcepts } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { ValueTypeSelector } from "../../ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { PayrollTypeList } from "./PayrollTypeList/PayrollTypeList";
import { BasicButton } from "../../../../theme/Component/BasicButton";



export const PayrollConcepts = () => {

    const payrollconcept = useDataBean(_PayrollConcepts);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [year, setYear] = useState<any>(_single.getCurrenYear())
    const [month, setMonth] = useState<any>(null)
    const [regexStr, setregexStr] = useState<any>(null)
    const [payrolltype, setPayrolltype] = useState<any>(null)
    const [valueType, setvalueType] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        payrollconcept.instance.getPayrollConcepts(year, month, payrolltype, valueType, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        payrollconcept.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        payrollconcept.deleteItemVoid(payrollconcept.bean).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        payrollconcept.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'IDPayroll Tipo', property: 'IDPayrollType', visible: true },
        { title: 'Nombre Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'Tipo de Coincepto', property: 'ValueTypeName', visible: true },
        { title: 'Nombre de Concepto', property: 'FactorName', visible: true },
        { title: 'Cuenta Débito', property: 'DebtAccountantIDName', visible: true },
        { title: 'Cuenta Crédito', property: 'CreditAccountantIDName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterCode', visible: true },
        { title: 'Valor', property: 'Value', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${payrollconcept.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Conceptos de Nómina por Tipo de Payroll">
            <div className="row">
                <div className="col-md-4">
                    <AccountantYear idSelector={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthEditorbyconst idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-4">
                    <PayrollTypeList idSelector={payrolltype} onChange={(e) => { setPayrolltype(e) }} />
                </div>
                <div className="col-md-4">
                    <ValueTypeSelector idSelector={valueType} onChange={(e) => { setvalueType(e) }} />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={payrollconcept.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={payrollconcept.bean.Code} onChange={payrollconcept.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={payrollconcept.bean.Name} onChange={payrollconcept.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {payrollconcept.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}